import { put, call, takeEvery } from "redux-saga/effects";
import * as apis from "../../network/apis/services";
import * as types from "./types";
import * as actions from "./actions";
import { showErrorMsg, showSuccessMsg } from "../../utils/Helpers";
import { ROUTE_PATHS } from "../../utils/RoutesPaths";
import history from "../../routes/History";

function* getServicesListSaga({ payload }) {
  try {
    const response = yield call(apis.getServicesList, payload);
    yield put(
      actions.getServicesResponse({
        list: response.data.services,
        meta: {
          currentPage: +response.headers["current-page"],
          count: +response.headers["total-count"],
          pages: +response.headers["total-pages"],
        },
      })
    );
    if (+response.headers["current-page"] > +response.headers["total-pages"]) {
      yield put(
        actions.getServicesRequest({
          ...payload,
          page: +response.headers["total-pages"],
        })
      );
    }
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
}

function* addServiceSaga({ payload, onSucess }) {
  try {
    yield call(apis.addService, payload);
    yield showSuccessMsg("addedSuccessfully");
    onSucess();
    // yield history.push(ROUTE_PATHS.services);
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
}

function* editServiceSaga({ payload, onsuccess }) {
  try {
    yield call(apis.editService, payload);
    yield showSuccessMsg("editedSuccessfully");
    onsuccess();
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
}

function* editServiceBulkSaga({ payload, onsuccess }) {
  try {
    yield call(apis.editServiceBulk, payload);
    yield showSuccessMsg("editedSuccessfully");
    onsuccess();
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
}

function* getServiceSaga({ payload }) {
  try {
    const response = yield call(apis.getServiceDetails, payload);
    yield put(
      actions.getServiceDetailsResponse({
        serviceDetails: response.data.service,
      })
    );
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
}

function* deleteServiceSaga({ payload }) {
  try {
    yield call(apis.deleteService, payload);
    yield showSuccessMsg("deletedSuccessfully");
    yield put(
      actions.getServicesRequest({
        items: 10,
        page: payload.currentPage,
      })
    );
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
}

export default function* ServicesSagas() {
  yield takeEvery(types.GET_SERVICES_REQUEST, getServicesListSaga);
  yield takeEvery(types.ADD_SERVICE_REQUEST, addServiceSaga);
  yield takeEvery(types.GET_SERVICE_DETAILS_REQUEST, getServiceSaga);
  yield takeEvery(types.EDIT_SERVICE_REQUEST, editServiceSaga);
  yield takeEvery(types.EDIT_SERVICE_BULK_REQUEST, editServiceBulkSaga);
  yield takeEvery(types.DELETE_SERVICE_REQUEST, deleteServiceSaga);
}
